<template>
  <div>
    <h1>Manage Users</h1>
    <p>This is the main component for your package's routes.</p>

    <UmisisDataListIntegrated cards :fields="fields" :use-store="userStore">
      <template #item="{ row }">
        <UserCard :user="row" />
      </template>
    </UmisisDataListIntegrated>
    <user-edit-modal v-if="selectedUser" ref="editUserModal" :user="selectedUser" />
  </div>
</template>

<script setup>
import { useUserManagerStore } from '../stores/userManagerStore.js'
import { nextTick, ref } from 'vue'
import UmisisDataTableIntegrated from '../../../../../../resources/js/components/umisis/generic/UmisisDataTableIntegrated.vue'
import { Button } from '../../../../../../resources/js/components/ui/button/index.js'
import UmisisDeleteItemButton from '../../../../../../resources/js/components/umisis/generic/UmisisDeleteItemButton.vue'
import { toast } from 'vue-sonner'
import { useI18n } from 'vue-i18n'
import UserEditModal from '../components/users/UserEditModal.vue'
import UmisisDataListIntegrated from '../../../../../../resources/js/components/umisis/generic/UmisisDataListIntegrated.vue'
import UserCard from '../components/users/UserCard.vue'
let userStore = useUserManagerStore()
const { t } = useI18n()
const fields = [
  { name: 'id', label: 'ID', sortable: true },
  { name: 'name', label: 'Name', sortable: true, searchable: true },
  { name: 'email', label: 'Email', sortable: true },
  { name: 'created_at', label: 'Created At', sortable: true, formatter: (value) => new Date(value).toLocaleDateString() },
  { name: 'actions', label: 'Actions' },
]

const deletedUser = (data) => {
  console.log('User deleted:', data)
  // Optionally refresh the user list or show a notification
  userStore.fetchItems()
  // send the notification
  toast(t('userManager.notifications.userDeleted'), {
    type: 'success',
  })
}

const editUserModal = ref(null)
const selectedUser = ref(null)
const editUser = (user) => {
  selectedUser.value = user
  nextTick( () => {
    editUserModal.value.openModal()
  })
}

const resetPassword = async (user) => {
  if(!confirm(t('userManager.confirmations.resetUserPassword', { userEmail: user.email }))) {
    return
  }
  console.log('Resetting password for user:', user)

}


</script>
